<template>
  <div :class="$style.wrap">
    <van-notice-bar
      wrapable
      :scrollable="false"
      :text="
        amount <= 50000
          ? '订单总额≤50000元的发票将以电子发票形式发到邮箱中'
          : '订单总额＞50000元的发票将以实体发票形式进行邮寄 '
      "
    />
    <div :class="$style.order_content">
      <p>订单信息</p>
      <div :class="$style.order_info">
        <span>订单数</span>
        <span>{{ number }}个</span>
      </div>
      <div :class="$style.order_info">
        <span>订单总额</span>
        <span>{{ amount }}元</span>
      </div>
      <p>地址信息</p>
    </div>

    <base-form
      ref="form"
      :items="data"
      label-width="5em"
      submit-text="确定"
      @submit="onSubmit"
    />
  </div>
</template>
<script>
import { doOder } from "@/http/invoice";
import BaseForm from "@/components/BaseForm";
export default {
  name: "invoiceMake",
  components: { BaseForm },
  data() {
    return {
      timer: null,
      orderIds: [],
      number: 0,
      amount: 0,
      data: [{ name: "name" }, { name: "telphone" }, { name: "addresss" }]
    };
  },
  mounted() {
    this.number = this.$route.query.number;
    this.amount = this.$route.query.amount;
    if (this.$route.query.orderIds) {
      this.orderIds = JSON.parse(this.$route.query.orderIds);
    }

    if (this.amount <= 50000) {
      this.data = [{ name: "emailAddress" }];
    }
  },

  methods: {
    async onSubmit(formData) {
      let parmas = {};
      if (this.amount <= 50000) {
        const { emailAddress } = formData;
        parmas = {
          email: emailAddress
        };
      } else {
        const { name, telphone, addresss } = formData;

        parmas = {
          tel: telphone,
          name: name,
          address: addresss
        };
      }
      parmas = {
        ...parmas,
        order_ids: this.orderIds
      };

      let res = await doOder(parmas);
      this.$refs.form.disabled = false;
      if (res.rcode === 0) {
        this.$router.replace({
          path: this._anchor.invoiceResult.path,
          query: {
            type: 1,
            time: res.data.dead_line
          }
        });
      } else if (res.rcode === 3001) {
        this.$router.replace({
          path: this._anchor.invoiceResult.path,
          query: {
            type: 3,
            time: res.data.dead_line
          }
        });
      } else if (res.rcode === 6002) {
        this.timer = setTimeout(() => {
          this.$router.replace({
            path: this._anchor.invoiceRules.path
          });
        }, 3000);
      } else {
        this.$router.replace({
          path: this._anchor.invoiceResult.path,
          query: {
            type: 0,
            message: res.data && res.data.rdesc
          }
        });
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style module lang="less">
.order_content {
  padding: 0.3rem 0.5rem 0 0.5rem;
  & > p {
    font-size: 0.28rem;
    font-weight: bold;
  }
  & > p:last-child {
    margin-top: 0.5rem;
  }
}
.order_info {
  margin: 0.28rem 0;
  span {
    display: inline-block;
    width: 1.6rem;
    font-size: 0.28rem;
  }
  span:first-child {
    color: #222;
  }
  span:last-child {
    color: #48d5af;
  }
}
</style>
